import React from 'react';
import { Footer } from '../components/HomePage';
import HowItWorksHeader from '../components/HowItWorks/HowItWorksHeader';
import EditPersonalInfo from '../components/MyProfile/EditPersonalInfo/EditPersonalInfo';

function EditPersonalInformationPage() {
  return (
    <>
      
      <EditPersonalInfo />
      <Footer />
    </>
  );
}

export default EditPersonalInformationPage;